
import React from 'react';
import { motion } from 'framer-motion';

interface TestimonialCardProps {
  testimonial: {
    name: string;
    location: string;
    quote: string;
    rating: number;
  };
  index: number;
}

const TestimonialCard = ({ testimonial, index }: TestimonialCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ delay: index * 0.2, duration: 0.6 }}
      viewport={{ once: true }}
      className="bg-white p-6 rounded-xl shadow-md"
    >
      <div className="flex text-yellow-400 mb-4 justify-center">
        {[...Array(testimonial.rating)].map((_, i) => (
          <span key={i}>⭐</span>
        ))}
      </div>
      <p className="text-gray-600 italic mb-4 text-center">"{testimonial.quote}"</p>
      <div className="font-semibold text-gray-900 text-center">{testimonial.name}</div>
      <div className="text-sm text-gray-500 text-center">{testimonial.location}</div>
    </motion.div>
  );
};

export default TestimonialCard;
